import React, { useRef, useEffect } from 'react';
import { Checkbox } from '@fashionnovateam/nova-ui-toolkit';

type CheckboxCellProps = {
  checked: boolean;
  indeterminate?: boolean;
  onChange: () => void;
};

export function CheckboxCell({
  checked,
  indeterminate = false,
  onChange,
}: CheckboxCellProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <div className="flex items-center justify-center w-full h-full">
      <Checkbox ref={ref} checked={checked} onChange={onChange} />
    </div>
  );
}
